import $ from 'jquery';
import Flickity from 'flickity';
import flickityEqualHeight from '../vendors/flickity-equal-height';
import DeviceManager from '../utils/device-manager';

flickityEqualHeight();

class ProductSlider {
    constructor($el) {
        this.$el = $el;

        if(this.$el.length) {
            this.$productsLists = this.$el.find('.products-slider__products-list');
            this.$productsGoups = this.$el.find('.products-slider__group');
            this.$productsListsWrapper = this.$el.find('.products-slider__products-lists');
            this.$buttons = this.$el.find('.products-slider__button');

            this.currentIndex = 0;
            this.productsCount = this.$productsLists.length;

            this._bindEvents();
            this._createSlider(DeviceManager.currentBreakpoint);
            this._onBreakpointChange();

            if(this.$productsGoups.length) {
                if(this.groupsSlider) {
                    this.groupsSlider.selectCell(0);
                }
                this.$productsGoups.eq(0).addClass('is-clicked');
            }
        }
    }

    _bindEvents() {
        this.$buttons.on('click', this._onButtonClick.bind(this));
        DeviceManager.on('device-manager:breakpointChange', this._onBreakpointChange.bind(this));
    }

    _createSlider(mode) {
        this.groupsSlider = new Flickity('.products-slider__groups', {
            prevNextButtons: false,
            pageDots: false,
            groupCells: true,
            // adaptiveHeight: true,
            // wrapAround: true,
            contain: true
            // cellAlign: 'left'
        });
        // this.groupsSlider.on('change', (index) => {
            // this.$productsLists.addClass('d-none');
            // this.$productsLists.eq(index).removeClass('d-none');
            // this.currentIndex = index;
        // });
        this.groupsSlider.on('staticClick', (event, pointer, cellElement, cellIndex) => {
            if(typeof cellElement !== 'undefined' && typeof cellIndex !== 'undefined') {
            // if(this.currentIndex !== cellIndex) {
                this.$productsLists.addClass('d-none');
                this.$productsGoups.removeClass('is-clicked');
                // this.currentIndex = cellIndex;
                this.$productsLists.eq(cellIndex).removeClass('d-none');
                this.$productsGoups.eq(cellIndex).addClass('is-clicked');
                // this.groupsSlider.selectCell(cellIndex);
            // }
            }
        });
    }

    _destroySlider() {
        this.groupsSlider.destroy();
    }

    _onButtonClick(e) {
        const $target = $(e.currentTarget);

        if($target.hasClass('products-slider__button--previous')) {
            // this.$productsLists.addClass('d-none');
            this.groupsSlider.previous();
        }
        else if($target.hasClass('products-slider__button--next')) {
            // this.$productsLists.addClass('d-none');
            this.groupsSlider.next();
        }
    }

    _onBreakpointChange(e) {
        if(
            DeviceManager.currentBreakpoint === 'mobile' && this.$productsGoups.length < 2 ||
            DeviceManager.currentBreakpoint === 'xsmall' && this.$productsGoups.length < 3 ||
            DeviceManager.currentBreakpoint === 'small' && this.$productsGoups.length < 3 ||
            DeviceManager.currentBreakpoint === 'medium' && this.$productsGoups.length < 4 ||
            DeviceManager.currentBreakpoint === 'large' && this.$productsGoups.length < 6
        ) {
            this.$buttons.hide();
        }
        else {
            this.$buttons.show();   
        }
        // this._destroySlider();
        // this._createSlider(DeviceManager.currentBreakpoint);
    }
}

export default ProductSlider;
